import { MonitorBase } from './_MonitorBase';

export class MonitorAudio extends MonitorBase {
  constructor(game, parent, config) {
    super(game, parent, { label: 'audio', ...config });

    this.game.cache.audio.events.on(Phaser.Cache.Events.ADD, this.updateMonitor, this);
    this.game.cache.audio.events.on(Phaser.Cache.Events.REMOVE, this.updateMonitor, this);
    this.updateMonitor();
  }

  shutdown() {
    this.game.cache.audio.events.off(Phaser.Cache.Events.ADD, this.updateMonitor, this);
    this.game.cache.audio.events.off(Phaser.Cache.Events.REMOVE, this.updateMonitor, this);
  }

  updateMonitor() {
    this._audioAudit = {};
    this._audioAudit.totalDuration = 0;
    this._audioAudit.audio = [];
    this.game.cache.audio.entries.each((key, audio) => {
      this._audioAudit.totalDuration += audio.duration;
      this._audioAudit.audio.push({
        key,
        duration: audio.duration,
      });
    });
    let audioString = `Duration : ${Math.round(this._audioAudit.totalDuration)} s`;
    this.setValue(audioString);
  }

  getLog() {
    let str = '';
    str += `\nTotal Audio\t\t: ${this._audioAudit.audio.length}`;
    str += `\nTotal Duration\t: ${Math.round(this._audioAudit.totalDuration).toLocaleString()} s`;
    str += `\nAudio in Cache\t:`;

    this._audioAudit.audio.forEach((audio) => {
      str += `\n\t${audio.key}`;
      str += `\n\t\tduration : ${audio.duration.toLocaleString()} s`;
    });
    return str;
  }
}
